import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  SaudeAlertasResponse,
  SaudeConfigResponse,
  SaudeOverviewResponse,
  UpdateSaudeConfigInput,
} from '../../types/saudeIntegracoes';
import { saudeIntegracoesService } from './services';

const toMessage = (error: unknown, fallback: string): string =>
  error instanceof Error ? error.message : fallback;

export const fetchSaudeIntegracoes = createAsyncThunk<
  SaudeOverviewResponse,
  void,
  { rejectValue: string }
>('saudeIntegracoes/fetch', async (_, { rejectWithValue }) => {
  try {
    return await saudeIntegracoesService.getOverview();
  } catch (error) {
    return rejectWithValue(toMessage(error, 'Erro ao carregar saúde de integrações'));
  }
});

export const fetchAlertasIntegracoes = createAsyncThunk<
  SaudeAlertasResponse,
  void,
  { rejectValue: string }
>('saudeIntegracoes/fetchAlertas', async (_, { rejectWithValue }) => {
  try {
    return await saudeIntegracoesService.getAlertas();
  } catch (error) {
    return rejectWithValue(toMessage(error, 'Erro ao carregar alertas'));
  }
});

export const refreshSaudeIntegracoes = createAsyncThunk<
  SaudeOverviewResponse,
  void,
  { rejectValue: string }
>('saudeIntegracoes/refresh', async (_, { rejectWithValue }) => {
  try {
    return await saudeIntegracoesService.refresh();
  } catch (error) {
    return rejectWithValue(toMessage(error, 'Erro ao atualizar saúde'));
  }
});

export const fetchSaudeConfig = createAsyncThunk<
  SaudeConfigResponse,
  void,
  { rejectValue: string }
>('saudeIntegracoes/fetchConfig', async (_, { rejectWithValue }) => {
  try {
    return await saudeIntegracoesService.getConfig();
  } catch (error) {
    return rejectWithValue(toMessage(error, 'Erro ao carregar configuração'));
  }
});

export const updateSaudeConfig = createAsyncThunk<
  { atualizados: number },
  UpdateSaudeConfigInput,
  { rejectValue: string }
>('saudeIntegracoes/updateConfig', async (input, { rejectWithValue }) => {
  try {
    return await saudeIntegracoesService.updateConfig(input);
  } catch (error) {
    return rejectWithValue(toMessage(error, 'Erro ao salvar configuração'));
  }
});
